"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationsSchema = void 0;
const zod_1 = require("zod");
const organization_schema_1 = require("./organization.schema");
exports.organizationsSchema = zod_1.z.array(organization_schema_1.organizationSchema).describe("List of organizations");
